import { IShip, IShipData, IShipDataEngine, IShipDataSail, IShipSettings } from "../Types"

/**
 * Pure derivations over an `IShip`. Kept free of React/DOM so the engine
 * sort/slice and `engineShortName` lookup can be unit-tested in isolation.
 *
 * `engines` sorts by `number` (missing numbers sort last) and clamps to the
 * ship's `engineCount`; `engineName` resolves a display name for an engine by
 * `id`, else by `nmeaNumber` (preferred) or `number`.
 */
export const Ship = {
  isSailingVessel(ship: IShip): boolean {
    return ship.vesselType == 2;
  },
  shipData(ship: IShip): IShipData {
    return ship.shipData || {} as IShipData;
  },
  shipSettings(ship: IShip): IShipSettings {
    return ship.shipSettings || {} as IShipSettings;
  },
  engines(ship: IShip): IShipDataEngine[] {
    const data = Ship.shipData(ship);
    if (data?.engines) {
      return data.engines.toSorted((a, b) => { return (a.number || 1000) - (b.number || 1000); }).slice(0, ship.engineCount);
    }
    return [];
  },
  sails(ship: IShip): IShipDataSail[] {
    const data = Ship.shipData(ship);
    if (data?.sails) {
      return data.sails;
    }
    return [];
  },
  engineName(ship: IShip, id?: string, engine?: number): string {
    if (!id && !engine) {
      return "#1";
    }
    const engines = Ship.engines(ship);
    if (engines) {
      const engineData = id ? engines.find((e: IShipDataEngine) => e.id == id) : engines.find((e: IShipDataEngine) => e.nmeaNumber != undefined ? e.nmeaNumber == engine : e.number == engine);
      if (engineData && engineData.engineShortName) {
        return engineData.engineShortName;
      }
    }
    return `#${engine}`;
  },
};
